import { TLocale } from 'shared/domain/valueObjects';

const PHONE: Record<TLocale, RegExp> = {
  pt: /^[1-9]{2}(?:[2-8]|9[1-9])[0-9]{3}[0-9]{4}$/,
  es: /^(\d{4}\d{5})$/,
  'es-CR': /^(\d{4}\d{4})$/,
  'es-UY': /^(\d{4}\d{4})$/,
};

export const REGEXES = { PHONE };
